import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65e0917a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-row three-cols mt-20" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "平均持仓位", -1))
const _hoisted_4 = { class: "custom-table full-width" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "label text-left" }, "指标名称"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "数据")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "最新", -1))
const _hoisted_7 = { class: "value orange-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "5日前", -1))
const _hoisted_9 = { class: "value orange-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "10日前", -1))
const _hoisted_11 = { class: "value orange-text" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "20日前", -1))
const _hoisted_13 = { class: "value orange-text" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "压力位", -1))
const _hoisted_15 = { class: "value red-text" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "上涨压力空间", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_18 = { class: "flex-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "最大筹码位", -1))
const _hoisted_20 = { class: "custom-table full-width" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "label text-left" }, "指标名称"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "数据")
  ])
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "最新", -1))
const _hoisted_23 = { class: "value black-text" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "5日前", -1))
const _hoisted_25 = { class: "value black-text" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "10日前", -1))
const _hoisted_27 = { class: "value black-text" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "20日前", -1))
const _hoisted_29 = { class: "value black-text" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "支撑位", -1))
const _hoisted_31 = { class: "value green-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "下跌支撑空间", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_34 = { class: "flex-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "集中度解析", -1))
const _hoisted_36 = { class: "custom-table full-width text-center" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "label text-left" }, "解析字段"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "90%筹码"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }, "70%筹码")
  ])
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "成本范围", -1))
const _hoisted_39 = { class: "black-text" }
const _hoisted_40 = { class: "black-text" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "集中度", -1))
const _hoisted_42 = { class: "black-text" }
const _hoisted_43 = { class: "black-text" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "集中状态", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "5日集中度变化", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "10日集中度变化", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "label text-left" }, "20日集中度变化", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.theme)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.meanHolder?.last)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_8,
              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.meanHolder?.day5)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_10,
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.meanHolder?.day10)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_12,
              _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.meanHolder?.day20)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.meanHolder?.zl)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.valueColorClass(_ctx.jzdData.meanHolder?.zlDiff)])
              }, _toDisplayString(_ctx.formatRate(_ctx.jzdData.meanHolder?.zlDiff)), 3)
            ])
          ])
        ])
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("table", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.maxChip?.last)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.maxChip?.day5)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.maxChip?.day10)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.maxChip?.day20)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_30,
              _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.formatPrice(_ctx.jzdData.maxChip?.zc)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_32,
              _createElementVNode("td", {
                class: _normalizeClass(["value", _ctx.valueColorClass(_ctx.jzdData.maxChip?.zcDiff)])
              }, _toDisplayString(_ctx.formatRate(_ctx.jzdData.maxChip?.zcDiff)), 3)
            ])
          ])
        ])
      ]),
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("table", _hoisted_36, [
          _hoisted_37,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _hoisted_38,
              _createElementVNode("td", _hoisted_39, _toDisplayString(_ctx.formatCost(_ctx.jzdData.jzd90)), 1),
              _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatCost(_ctx.jzdData.jzd70)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_41,
              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatRateValue(_ctx.jzdData.jzd90?.jzd)), 1),
              _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.formatRateValue(_ctx.jzdData.jzd70?.jzd)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_44,
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdColor(_ctx.jzdData.jzd90?.jzdStateColor))
              }, _toDisplayString(_ctx.jzdData.jzd90?.jzdState || '-'), 3),
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdColor(_ctx.jzdData.jzd70?.jzdStateColor))
              }, _toDisplayString(_ctx.jzdData.jzd70?.jzdState || '-'), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_45,
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd90?.diffDay5))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd90?.diffDay5)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd70?.diffDay5))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd70?.diffDay5)), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_46,
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd90?.diffDay10))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd90?.diffDay10)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd70?.diffDay10))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd70?.diffDay10)), 3)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_47,
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd90?.diffDay20))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd90?.diffDay20)), 3),
              _createElementVNode("td", {
                class: _normalizeClass(_ctx.jzdDiffColor(_ctx.jzdData.jzd70?.diffDay20))
              }, _toDisplayString(_ctx.formatJzdDiff(_ctx.jzdData.jzd70?.diffDay20)), 3)
            ])
          ])
        ])
      ])
    ])
  ], 2))
}